export default {"src":"/_next/static/media/automate.5a020c8b.svg","height":69,"width":89};